import React from 'react';
import { Card as AntCard } from 'antd';

/**
 * Wrapper component for Ant Design Card
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Card functionality and sub-components.
 * 
 * @component
 * @example
 * import { Card } from '../GeneralComponents/ui';
 * 
 * <Card title="Card Title">
 *   <Card.Meta title="Meta Title" description="Meta Description" />
 *   Card content
 * </Card>
 * 
 * @see https://ant.design/components/card/ - Ant Design Card documentation
 */
const Card = (props) => {
  return <AntCard {...props} />;
};

// Preserve Card sub-components
Card.Meta = AntCard.Meta;
Card.Grid = AntCard.Grid;

export default Card;

